import React, { Component } from 'react';
import HeaderElement from './HeaderElement';
import FooterElement from './FooterElement';
import Builder from './Builder';
import Form    from './Form';
import Utils    from './Utils';
import TutorialPopup from './TutorialPopup';
import SizeSelector from './SizeSelector';
import RampaCells from './RampaCells';

import _ from 'lodash';

export default class Home extends Component {

	constructor(props) {
		super(props);

		this.state = { 
			editing: true,
			saved: false,
			ground: null,
			background: 'green.png',
			elements:   [],
			selectedElement: null,
			mouseCoords: null,
			menu: null,
			showTutorial : false,
			selectedMenuElement: null
		};

		

		this.onFinishEditingClick 	= this.onFinishEditingClick.bind(this);
		this.onStartEditingClick  	= this.onStartEditingClick.bind(this);

		this.onGroundSelect     	= this.onGroundSelect.bind(this);
		this.onBackgroundSelect 	= this.onBackgroundSelect.bind(this);
		this.onMenuElementClick 	= this.onMenuElementClick.bind(this);
		
		this.onElementSelect    	= this.onElementSelect.bind(this);
		this.onElementClick    		= this.onElementClick.bind(this);
		this.onElementDragStart  	= this.onElementDragStart.bind(this);
		this.onElementDragEnd  		= this.onElementDragEnd.bind(this);
		this.onShowTutorial     	= this.onShowTutorial.bind(this);

		this.onGridClick     		 = this.onGridClick.bind(this);
		this.onGridDrop     		 = this.onGridDrop.bind(this);
		this.onGridDragEnter     	 = this.onGridDragEnter.bind(this);
		this.onGridMouseMove    	 = this.onGridMouseMove.bind(this);
		this.onClick    			 = this.onClick.bind(this);
		this.onContextMenu    		 = this.onContextMenu.bind(this);
		this.onMenuClick    		 = this.onMenuClick.bind(this);
		this.onReset    			 = this.onReset.bind(this);
		
		this.onSave    			 	 = this.onSave.bind(this);

		// Esto es para evitar que haya scroll en iPad
		//	document.ontouchmove = function(e){ e.preventDefault(); }

		// console.log('getOccupiedCells');
		// Resources.buildings[0].col = 10;
		// Resources.buildings[0].row = 10;
		// console.log(Resources.buildings[0]);
		// console.log(Utils.getOccupiedCells(Resources.buildings[0]));

	}

	componentDidMount() {

		if (location.hash.match(/sizeSample/)) {
			// this.setState({
			// 	elements: [{"src":"buildings/Constructed_FenceWood-0.png","size":1,"top":112.3779296875,"left":689.599609375,"row":3,"col":2,"canDrop":true,"id":"1","selected":false},{"src":"buildings/Constructed_FenceWood-0.png","size":2,"top":159.526611328125,"left":771.80078125,"row":3,"col":5,"canDrop":true,"id":"3","selected":false},{"src":"buildings/Constructed_FenceWood-0.png","size":3,"top":222.3914794921875,"left":881.40234375,"row":3,"col":9,"canDrop":true,"id":"4","selected":false},{"src":"buildings/Constructed_FenceWood-0.png","size":4,"top":285.25628662109375,"left":991.00390625,"row":3,"col":13,"canDrop":true,"id":"5","selected":false},{"src":"buildings/Constructed_FenceWood-0.png","size":5,"top":363.83740234375,"left":1128.005859375,"row":3,"col":18,"canDrop":true,"id":"6","selected":false},{"src":"buildings/Constructed_FenceWood-0.png","size":6,"top":552.4320068359375,"left":1073.205078125,"row":10,"col":23,"canDrop":true,"id":"7","selected":false}]
			// })
			
		}

		if (process.env.NODE_ENV === 'development') {
				//this.state.background = 'blue.png';
				// this.state.ground     = 'green.png';
				this.setState({
					ground: 'green.png'
				})
				// this.state.elements = [{"src":"nature/tree_90-0.png","top":473.85089111328125,"left":936.203125,"row":10,"col":18,"canDrop":true,"selected":false},{"src":"nature/tree_92-0.png","top":410.98602294921875,"left":1045.8046875,"row":6,"col":18,"canDrop":true,"selected":false},{"src":"nature/tree_95-0.png","top":489.567138671875,"left":1018.404296875,"row":9,"col":20,"canDrop":true,"selected":false},{"src":"nature/BushRounded_04-0.png","top":269.54010009765625,"left":908.802734375,"row":4,"col":11,"canDrop":true,"selected":false},{"src":"buildings/Bunny_Wife-0.png","top":552.4320068359375,"left":744.400390625,"row":16,"col":17,"canDrop":true,"selected":false},{"src":"buildings/PoleGate-0.png","top":395.26983642578125,"left":415.5957336425781,"row":17,"col":6,"canDrop":true,"selected":false},{"src":"buildings/ROYAL_EGG-0.png","top":410.98602294921875,"left":278.59381103515625,"row":20,"col":4,"canDrop":true,"selected":false},{"src":"buildings/shop_03-0.png","top":175.2427978515625,"left":799.201171875,"row":3,"col":6,"canDrop":true,"selected":false},{"src":"buildings/wind_mill01-0.png","top":505.2833251953125,"left":388.19537353515625,"row":21,"col":9,"canDrop":true,"selected":false},{"src":"buildings/shop_85-0.png","top":536.7157592773438,"left":1155.40625,"row":8,"col":24,"canDrop":true,"selected":false},{"src":"buildings/Door_01-0.png","top":253.8238525390625,"left":442.9961242675781,"row":12,"col":2,"canDrop":true}];
		}
		
		document.addEventListener('keydown', (event) => {
			if (event.keyCode === 27) { // Escape key
        		this.setState({menu: null, selectedElement: null, selectedMenuElement: null});
				this.deselectAll();
			}
		});
	}

	onReset(event) {
		if(confirm('¿Estás seguro de que quieres borra todo?')) {

			this.setState({
				editing: true,
				ground: null,
				background: 'green.png',
				elements:   [],
				selectedElement: null,
				mouseCoords: null,
				menu: null,
				showTutorial : false
			})
		};
	}

	

	onClick(event) {
		this.deselectAll();
		this.setState({menu: null, selectedMenuElement: null});
	}

	onContextMenu(event) { // Right click
		this.setState({menu: null, selectedElement: null, selectedMenuElement: null});
		this.deselectAll();
		event.preventDefault();
	}

	onGroundSelect(value) {
        this.setState({menu: null, ground:value});
    }

	onBackgroundSelect(value) {
        this.setState({menu: null, background:value});
    }

	onElementSelect(element) {
        this.setState({
			menu: null, 
			selectedElement: element,
			isDragging: false,
			draggedElement: null,
			selectedMenuElement: null
		});
    }

	onElementDragStart(element, event) {
		this.setState({
			menu: null, 
			selectedElement: null,
			isDragging: true,
			draggedElement: element
		});
	}

	onElementDragEnd(element, event) {
		this.setState({
			isDragging: false,
			draggedElement: null,
			selectedMenuElement: null
		});
	}
	
	deleteElement(element) {
		this.setState((prev, props) => {
			
        	const elements = _.filter(prev.elements, function(item) {
				return item.id !== element.id
			});

			return {
            	elements: elements
			};
		});
    }

	onMenuElementClick(item, event) {
		this.setState({
            selectedMenuElement: item
        });
    }

    onElementClick(element, event) {
		event.stopPropagation();
		if (!this.state.editing) { return; }

		this.setState((prev, props) => {
			const elements = _.clone(prev.elements);
			_.each(prev.elements, (item, key) => {
				if (item === element) {
					item.selected = true;
				} else {
					item.selected = false;
				}
			});
			return { elements: elements };
		});
    }

	onGridMouseMove(obj) {
		this.setState((prevState, props) => {
			const element = prevState.selectedElement;

			if (!element) {
				return;
			}

			element.top  = obj.top  + obj.height;
			element.left = obj.left + (obj.width / 2);
			element.row  = obj.row;
			element.col  = obj.col;

			if (element.offset) {
				element.top  += element.offset;
			}

			element.canDrop = this.canDrop(element);

			return {
				selectedElement: element
			};
		});
	}

	onGridDrop(position, event) {
		if (!this.state.draggedElement) { 
			return;
		}
		
		if (!this.canDrop(this.state.draggedElement)) {
			this.setState({ 
				isDragging: false,
				draggedElement: null,
				selectedMenuElement: null
			});
			return false;
		}

		// Si es un elemento que ya está puesto en 
		// el canvas y solo lo estamos moviendo
		if (this.state.draggedElement.id) { 
			this.deleteElement(this.state.draggedElement);
		}

		const element = _.clone(this.state.draggedElement);
		
		this.addElement(position, element);
		this.setState({ 
			isDragging: false,
			draggedElement: null,
			selectedMenuElement: null
		});
	}

	onGridDragEnter(position, event) {
		
		this.setState((prevState, props) => {
			const element = _.clone(prevState.draggedElement);

			if (!element) { return; }

			element.row  = position.row;
			element.col  = position.col;

			element.canDrop = this.canDrop(element);

			return { draggedElement: element };
		});

	}

	onGridClick(position, event) {
		event.stopPropagation();

		// @todo, a lo mejor aquí hay que leer prevState
		if (!this.state.selectedElement) { 
			return;
		}

		const element = _.clone(this.state.selectedElement);

		if (!this.canDrop(element)) {
			return false;
		}
		
		this.addElement(position, element);

		const newState = {
			selectedMenuElement: null
		};

		if (!event.shiftKey) {
			newState.selectedElement = null;
		}

		this.setState(newState);
	}

	onFinishEditingClick() {
		this.deselectAll();

		const mapData = {
			ground: 	this.state.ground,
            background: this.state.background,
            elements: 	this.state.elements
		};

		this.setState({
			editing: false,
			mapData: JSON.stringify(mapData)
		});
	}
	
	onStartEditingClick() {
		this.setState({editing:true});
	}

	onSave(res) {
		this.setState({saved : true});
	}

	onMenuClick(value, event) {
		this.setState({
			menu: this.state.menu === value ? null : value,
			showTutorial: false,
			selectedMenuElement: null
		});
		event.stopPropagation();
	}
	
	addElement(position, element) {
		
		if (!this.canDrop(element)) {
			return false;
		}

        element.top  = position.top  + position.height;
        element.left = position.left + (position.width/2);
		element.row = position.row;
		element.col = position.col;
		element.id  = _.uniqueId();

		if (element.offset) {
			element.top  += element.offset;
		}

        this.setState((prev, props) => {
            return { 
				elements: prev.elements.concat([element])
			}
        });
	}

	canDrop(element) {
		
		
		const wantedCells = Utils.getOccupiedCells(element);

		// Si se sale del mapa, nanai
		for (var i = 0; i < wantedCells.length; i++) {
			const cell = wantedCells[i];
			if (cell[0] < 0 || cell[1] < 0) {
				return false;
			}
		}

		// No deben "intersectar" en ninguna celda de la rampa
		let intersection = _.intersectionWith(RampaCells, wantedCells, _.isEqual);

		if (intersection.length > 0) {
			return false;
		}

		// No deben "intersectar" en ninguna celda de otro elemento
		for (var j = 0; j < this.state.elements.length; j++) {
			let subElement = this.state.elements[j];
			const busyCells = Utils.getOccupiedCells(subElement);
			intersection = _.intersectionWith(busyCells, wantedCells, _.isEqual);
			if (intersection.length > 0) {
				return false;
			}
		}

		return true;
	}

	

	deselectAll() {
		this.setState((prev, props) => {
			const elements = _.clone(prev.elements);
			_.each(elements, (item) => {
				item.selected = false;
			});
			return { elements: elements };
		});
	}

	onShowTutorial(){
		this.setState({
			showTutorial: true,
			menu: null
		});
	}

	render() {

		let className = 'home';

		if (this.state.isDragging) {
			className += ' is-dragging';
		}

		if (this.state.selectedElement) {
			className += ' has-selected-element';
		}

		// Es never used
		//const draggedElement = this.state.draggedElement;
		
		return (
			<div className={className} onClick={this.onClick} onContextMenu={this.onContextMenu}>
				
				{this.state.showTutorial}
				<div className="bg-app" style={{backgroundImage:'url(img/background/' + this.state.background + ')'}} ></div>

				<HeaderElement />

				<Builder 
					onBackgroundSelect={this.onBackgroundSelect}
					onGroundSelect={this.onGroundSelect}
					
					onElementSelect={this.onElementSelect}
					onElementClick={this.onElementClick}
					onElementDragStart={this.onElementDragStart}
					onElementDragEnd={this.onElementDragEnd}
					onMenuElementClick={this.onMenuElementClick}

					onGridClick={this.onGridClick}
					onGridDrop={this.onGridDrop}
					onGridDragEnter={this.onGridDragEnter}
					onGridMouseMove={this.onGridMouseMove}

					onMenuClick={this.onMenuClick}
					onShowTutorial={this.onShowTutorial}
					onStartEditingClick={this.onStartEditingClick}
					onFinishEditingClick={this.onFinishEditingClick}
					
					deleteElement={this.deleteElement.bind(this)}

					menu={this.state.menu}
					showTutorial={this.state.showTutorial}
					ground={this.state.ground}
					elements={this.state.elements}
					editing={this.state.editing}
					saved={this.state.saved}
					selectedElement={this.state.selectedElement}
					draggedElement={this.state.draggedElement}
					selectedMenuElement={this.state.selectedMenuElement}
					/>

				{
					!this.state.editing && 
						<Form mapData={this.state.mapData}  onSave={this.onSave} />
				}

				{
					this.state.selectedMenuElement &&
						<SizeSelector item={this.state.selectedMenuElement} onElementSelect={this.onElementSelect} />
				}
				
				<FooterElement onReset={this.onReset}  editing={this.state.editing} saved={this.state.saved} />
				{this.state.showTutorial}
				{
					this.state.showTutorial && <TutorialPopup  layout="home"/>
				}
				
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/Home.js